module.exports = __webpack_public_path__ + "static/media/ExitModalMobile.4914db39.png";